import React from 'react';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const PaymentSROInfo = ({ closeModal }) => {
    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>QR-код для оплаты</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='qrBox'>
                        <img src="/img/payments/mainQR.png" alt="QR-код для оплаты временно недоступен" />
                    </div>
                    <p className='description'>Наведите камеру в банковском приложении на QR-код выше, чтобы реквизиты вставились автоматически</p>
                </div>
            </div>
        </div>
    )
}

export default PaymentSROInfo;